import { render, staticRenderFns } from "./BaseSettingTabTitle.vue?vue&type=template&id=42bae605&scoped=true&"
import script from "./BaseSettingTabTitle.vue?vue&type=script&lang=js&"
export * from "./BaseSettingTabTitle.vue?vue&type=script&lang=js&"
import style0 from "./BaseSettingTabTitle.vue?vue&type=style&index=0&id=42bae605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bae605",
  null
  
)

export default component.exports